// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","confirmButton":"confirmButton--xh-KK","resendButton":"resendButton--yS7h8"};